<template>
    <div>
        <carrier-information
            :carrier_id="carrier_id"
        ></carrier-information>
        <carrier-emails
            v-if="$canAccess(21,23)"
            :carrier_id="carrier_id"
        ></carrier-emails>
        <cashflow
            :source_id="carrier_id"
            sourceFn="carrierCashflow"
            label="Carrier"
            :name="carrierDetails.name"
        ></cashflow>
        <carrier-products
            :carrier_id="carrier_id"
        ></carrier-products>

    </div>
</template>

<script type="text/babel">

    import CarrierInformation from './CarrierInformation.vue';
    import CarrierProducts from './CarrierProducts.vue';
    import CarrierEmails from './CarrierEmails.vue';
    import Cashflow from '../assets/Cashflow.vue';
    import DropdownConfirmation from '../assets/DropdownConfirmation.vue';

    export default {
        data: function () {
            return {
                carrier_id: '',
                carrierDetails: {},
                carrierProducts:[]
            }
        },
        components: {
            CarrierInformation,
            CarrierProducts,
            Cashflow,
            CarrierEmails
        },
        created(){
            this.carrier_id = this.$route.params.carrier_id || null;
            this.fetchCarrierData();
        },
        methods:{
            fetchCarrierData(){

                this.$send(this, 'carrierDetails', {
                    carrier_id: this.$route.params.carrier_id
                }).then(r => {
                    this.carrierDetails = r.carrierDetails;
                });

/*
                this.$http.post('http://10.0.24.14/api.php', {
                    function: 'carrierDetails',
                    data: {
                        carrier_id: this.$route.params.carrier_id
                    }
                }, {
                    emulateJSON: true
                }).then(function(response){
                    if(response.body.status){
                        this.carrierDetails = response.body.data.carrierDetails;
                    }
                });
                */
            },
        }
    }
</script>


// WEBPACK FOOTER //
// CarrierDetails.vue?7bf295b8